import {Injectable} from '@angular/core';
import {SkipInterception} from '../../model/response-status.model';
import {
  ErrorModel,
  GlobalMessageService,
  GlobalMessageType,
  HttpErrorHandler,
  Priority,
  RoutingService,
} from '@spartacus/core';
import {HttpErrorResponse, HttpRequest, HttpStatusCode} from '@angular/common/http';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';

/**
 * Error handler for Bad requests with http status 400.
 */
@Injectable({
  providedIn: 'root',
})
export class BadRequestHandler extends HttpErrorHandler {
  responseStatus = HttpStatusCode.BadRequest;

  constructor(
    private routingService: RoutingService,
    public globalMessageService: GlobalMessageService,
    public authService: DcpAuthService
  ) {
    super(globalMessageService);
  }

  handleError(request: HttpRequest<any>, response: HttpErrorResponse): void {
    if (response?.error?.errors instanceof Array) {
      response.error.errors.forEach((error: ErrorModel) => {
        if (error.type === SkipInterception.UNKNOWN_IDENTIFIER_ERROR) {
          if (request.params.get(SkipInterception.SKIP_INTERCEPTOR) === SkipInterception.UNKNOWN_IDENTIFIER_ERROR) {
            request.params.delete(SkipInterception.SKIP_INTERCEPTOR);
          } else {
            this.handleUnknownIdentifierError();
          }
        } else if (error.type === 'OAuth2AuthenticationError') {
          this.handleOAuth2AuthenticationError();
        }
      });
    }
  }

  /**
   * Handles UnknownIdentifierErrors.
   * For example when a product is opened that is not available in a country.
   */
  handleUnknownIdentifierError() {
    this.globalMessageService.add({key: 'pageMetaResolver.productUnavailable'}, GlobalMessageType.MSG_TYPE_INFO);
    this.routingService.go({
      cxRoute: 'search',
      params: {
        query: '',
      },
    });
  }

  getPriority(): Priority {
    return Priority.NORMAL;
  }

  /**
   * Handles OAuth2AuthenticationError.
   * For example when a JWT token has expired.
   */
  private handleOAuth2AuthenticationError() {
    this.authService.onAuthenticationError();
  }
}
